import React, { useEffect } from 'react';
import { Sparkles, Recycle, Clock, Users, Award, Truck } from 'lucide-react';
import UseCaseTemplate from '../../components/UseCaseTemplate';

const HERO_IMG = '/assets/images/event.png';

const EventsCatering = () => {
  useEffect(() => {
    document.title = 'Events and Catering | Where It’s Used | Magomeal';
  }, []);

  const benefits = [
    {
      icon: <Recycle size={28} />,
      title: 'Zero-Waste Service',
      description: 'Eliminate disposable cups and cutlery from your events. Guests can simply eat or compost everything they used.',
    },
    {
      icon: <Sparkles size={28} />,
      title: 'Memorable Experience',
      description: 'Surprise and delight attendees with edible drinkware that becomes a talking point of your event.',
    },
    {
      icon: <Clock size={28} />,
      title: 'Faster Cleanup',
      description: 'Less waste collection, fewer bins, no plastic sorting. Save staff time and reduce post-event logistics.',
    },
    {
      icon: <Users size={28} />,
      title: 'Built for Volume',
      description: 'Sturdy enough for high-throughput catering, from corporate galas to weddings and large festivals.',
    },
    {
      icon: <Award size={28} />,
      title: 'Premium Branding',
      description: 'Position your catering company as innovative and sustainability-led to win modern, ESG-aware clients.',
    },
    {
      icon: <Truck size={28} />,
      title: 'Bulk Friendly',
      description: 'Available in carton quantities with reliable lead times across the Benelux region.',
    },
  ];

  return (
    <UseCaseTemplate
      eyebrow="Where It’s Used"
      title="Events and Catering"
      subtitle="Edible cups and cutlery for unforgettable, zero-waste events."
      heroImage={HERO_IMG}
      imageAlt="Cupffee edible cups served at a catering event"
      intro="From weddings and festivals to corporate galas and pop-up events, catering teams are under growing pressure to reduce single-use plastic without sacrificing quality or speed of service. Magomeal’s edible cups and cutlery are designed for high-volume environments: they hold hot drinks without leaking, stay crispy with cold beverages, and can be enjoyed or composted after use, removing waste from your event entirely."
      benefitsTitle="Why event & catering pros choose Magomeal"
      benefitsSubtitle="Designed for the demands of professional service."
      benefits={benefits}
      ctaTitle="Plan your next zero-waste event"
      ctaText="Tell us about your event size and menu, and we’ll recommend the right mix of edible cups and cutlery."
      primaryCta={{ label: 'Request a Quote', to: '/contact' }}
      secondaryCta={{ label: 'Browse Products', to: '/shop' }}
    />
  );
};

export default EventsCatering;
